import { Component } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-address-cell',
  templateUrl: './address-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class AddressCellComponent extends InlineEditCellDirective {
  displayAddressDialog = false

  /* True while the cell is completing the edit event. The dialog fires an 'onHide' event both when clicking the close and the submit button.
   * In the latter case we dont want to restore the cells original content and need to prevent the abortCellEdit function from being called.
   */
  isSaving = false

  triggerEdit() {
    // Since the address is not a primitive we need to make a real copy
    this.originalContent = Object.assign({}, this.rowData[this.fieldName])

    this.displayAddressDialog = true
  }

  onSave() {
    this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
    this.isSaving = true
    this.displayAddressDialog = false
  }

  onHide() {
    if (this.isSaving) this.isSaving = false
    else this.abortCellEdit(null)
  }
}
